const config = {
  baseUrl: 'https://wp.nystromkonst.com/',
}

export default config.baseUrl
